import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<
    TournamentPositionsResponse,
    { tournamentId: number; teamId: number; position: number }
  >({
    query: ({ tournamentId, teamId, position }) => ({
      url: `v4/pitch-owner/tournaments/${tournamentId}/custom/teams/${teamId}/update-position`,
      method: 'POST',
      body: { position },
    }),
  });

type TournamentPositionsResponse = {
  data: {
    message: string;
  };
  code: number;
};
